import { myFetch, HttpMethod } from './baseService';

// Interfaz genérica para la respuesta (ajustar según la respuesta real del servidor)
export interface ApiEnvelope<T> {
  code: string | number;
  message: string;
  object_: T;
}

// Tipo genérico para el objeto de respuesta (puedes ajustarlo después de probar la API)
export interface UploadResponse {
  status: string;
  processedRecords?: number;
}

// Función para cargar el archivo Excel directamente (multipart/form-data)
export const uploadPaymentFile = async (file: File) => {
  // Crear FormData para enviar el archivo
  const formData = new FormData();
  formData.append('archivoExcel', file);

  // Usar myFetch - Axios detectará automáticamente FormData y establecerá el Content-Type correcto
  const envelope = await myFetch<ApiEnvelope<UploadResponse>>(
    'carga_archivo/cargar_excel_valores_pendientes_administracion',
    HttpMethod.POST,
    formData
  );

  // Devolver el envelope completo para que el componente maneje el código de respuesta
  return envelope;
};

// Nueva interfaz para la solicitud de ObtenerTodos
export interface GetAllValoresPendientesRequest {
  vpt_unidad_residencial: string;
  vpt_apartamento: string;
  vpt_encargado: string;
  vpt_estatus: string;
}

// Nueva interfaz para los items de valores pendientes (basado en la respuesta de ejemplo)
export interface ValorPendiente {
  vpa_apartamento: string;
  vpa_apartamento_nombre: string;
  vpa_unidad: string;
  vpa_unidad_nombre: string;
  vpa_torre: string;
  vpa_torre_nombre: string;
  vpa_propietario: string;
  vpa_propietario_nombre: string;
  vpa_encargado: string;
  vpa_encargado_nombre: string;
  vpa_estatus: string;
  vpa_estatus_nombre: string;
  vpa_1_a_30: number;
  vpa_31_a_60: number;
  vpa_61_a_90: number;
  vpa_mas_de_90: number;
  vpa_por_vencer: number;
  vpa_valor_total: number;
  vpa_enviado: number;
}

// Función para obtener todos los valores pendientes
export const getAllValoresPendientes = async (payload: GetAllValoresPendientesRequest) => {
  const envelope = await myFetch<ApiEnvelope<ValorPendiente[]>>(
    'valores_pendientes_administracion/ObtenerTodos',
    HttpMethod.POST,
    payload
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};

export interface SendEmailsRequest {
  vpt_unidad_residencial: string;
  vpt_enviado: string;
}

export const sendEmailsToAll = async (payload: SendEmailsRequest) => {
  const envelope = await myFetch<ApiEnvelope<ValorPendiente[]>>(
    'valores_pendientes_administracion/EnviarCorreoATodos',
    HttpMethod.POST,
    payload
  );

  return envelope;
};

export interface EstatusValorPendiente {
  evp_codigo: string;
  evp_nombre: string;
}

// Función para obtener todos los estatus de valores pendientes
export const getAllEstatusValoresPendientes = async () => {
  const envelope = await myFetch<ApiEnvelope<EstatusValorPendiente[]>>(
    'estatus_valores_pendientes_administracion/ObtenerTodos',
    HttpMethod.POST,
    {} // Sin cuerpo según especificación
  );

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};

// Interfaz para la solicitud de filtrado por estatus
export interface GetValoresByEstatusRequest {
  vpt_unidad_residencial: string;
  vpt_estatus1: string;
  vpt_estatus2: string;
  vpt_estatus3: string;
  vpt_estatus4: string;
  vpt_enviado: string;
}

// Función para obtener valores pendientes filtrados por estatus
export const getValoresPendientesByEstatus = async (payload: GetValoresByEstatusRequest) => {
  const envelope = await myFetch<ApiEnvelope<ValorPendiente[]>>(
    'valores_pendientes_administracion/ObtenerTodosSegunEstatusApartamento',
    HttpMethod.POST,
    payload
  );

  // Verificar si el código es -1 (No encontrados)
  if (envelope.code === "-1" || envelope.code === -1) {
    throw new Error(envelope.message || 'No se encontraron registros');
  }

  if (!envelope.object_) {
    throw new Error('Respuesta inesperada del servidor');
  }

  return envelope.object_;
};

// Interfaz para envío de correos por estatus
export interface SendEmailsByEstatusRequest {
  vpt_unidad_residencial: string;
  vpt_estatus1: string;
  vpt_estatus2: string;
  vpt_estatus3: string;
  vpt_estatus4: string;
  vpt_enviado: string;
}

// Función para enviar correos filtrados por estatus
export const sendEmailsByEstatus = async (payload: SendEmailsByEstatusRequest) => {
  const envelope = await myFetch<ApiEnvelope<ValorPendiente[]>>(
    'valores_pendientes_administracion/EnviarCorreoSegunEstatusApartamento',
    HttpMethod.POST,
    payload
  );

  return envelope;
};